<template>
  <div class="treeBox">
    <el-tree ref="async-router-tree" :allow-drag="allowDrag" :allow-drop="allowDrop" :default-expanded-keys="[0]"
             :expand-on-click-node="false" :load="loadNode" :props="props" draggable lazy
             node-key="id" @node-drag-end="handleDragEnd">
        <span slot-scope="{ node, data }" class="custom-tree-node">
        <span>{{ node.label }}</span>
        <span>
          <template v-if="data.id === 0">
            <Button class="add-root-btn" icon="ios-add" size="small" type="primary"
                    @click="editNode(node, data, 'append')"></Button>
          </template>
          <template v-else>
            <Button icon="ios-add" size="small" type="default" @click="editNode(node, data, 'append')"></Button>
            <Button icon="ios-remove" size="small" type="default" @click="removeNodeConfirmed(node, data)"></Button>
            <Button icon="md-create" size="small" type="default" @click="editNode(node, data, 'edit')"></Button>
          </template>
        </span>
      </span>
    </el-tree>
    <div v-if="isNodeEdited" class="modal-mask">
      <Card class="modal-mask-form">
        <p slot="title">
          <Icon size="24" type="ios-create-outline"/>
          <span>节点信息新增</span>
        </p>
        <Form ref="asyncRoute" :label-width="200" :model="asyncRoute" :rules="ruleAsyncRoute">
          <FormItem label="类型（type）" prop="type">
            <Select v-model="asyncRoute.type" filterable>
              <Option label="一级菜单" value="menu1"></Option>
              <Option label="二级菜单（不含三级菜单），三级菜单" value="menu2"></Option>
              <Option label="二级菜单（含三级菜单）" value="menu2-sp"></Option>
              <Option label="非菜单页面" value="non-menu"></Option>
              <Option label="按钮" value="button"></Option>
            </Select>
          </FormItem>
          <FormItem label="标题（title）" prop="title">
            <Input v-model="asyncRoute.title" placeholder="路由标题" type="text">
              <Icon slot="prepend" type="md-create"></Icon>
            </Input>
          </FormItem>
          <template v-if="asyncRoute.type !== 'button'">
            <FormItem label="菜单图标名（icon）" prop="icon">
              <Input v-model="asyncRoute.icon" placeholder="菜单图标名，参考iView的图标库" type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
            <FormItem label="路由名（name）" prop="name">
              <Input v-model="asyncRoute.name" placeholder="路由名" type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
            <FormItem label="路由访问路径（path）" prop="path">
              <Input v-model="asyncRoute.path"
                     placeholder="一级菜单路径必须以 ' / '开头，二级及其他路径可不以 ' / '开头，区别详见前端readme文档 "
                     type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
            <FormItem label="vue组件（component）" prop="component">
              <Input v-model="asyncRoute.component" placeholder="组件位于src下路径，例如：views/main/main.vue"
                     type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
          </template>
          <Row>
            <Col span="14">
              <FormItem label="接口地址">
                <Input v-model="asyncRoute.url" placeholder="接口地址" type="text">
                  <Icon slot="prepend" type="md-create"></Icon>
                </Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem :label-width="90" label="请求方式">
                <Select v-model="asyncRoute.httpMethod" clearable filterable placeholder="请选择">
                  <Option value="GET">get</Option>
                  <Option value="PUT">put</Option>
                  <Option value="POST">post</Option>
                  <Option value="DELETE">delete</Option>
                </Select>
              </FormItem>
              <Icon slot="prepend" type="md-create"></Icon>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Button :disabled="isSubmitDisabled" type="primary" @click="handleSubmit('asyncRoute')">保存</Button>
            <Button type="default" @click="cancel">取消</Button>
          </Row>
        </Form>
      </Card>
    </div>
    <div v-if="isNodeAdd" class="modal-mask">
      <Card class="modal-mask-form">
        <p slot="title">
          <Icon size="24" type="ios-create-outline"/>
          <span>节点信息编辑</span>
        </p>
        <Form ref="asyncRoute" :label-width="200" :model="asyncRoute" :rules="ruleAsyncRoute">
          <FormItem label="类型（type）" prop="type">
            <Select v-model="asyncRoute.type" filterable>
              <Option label="一级菜单" value="menu1"></Option>
              <Option label="二级菜单（不含三级菜单），三级菜单" value="menu2"></Option>
              <Option label="二级菜单（含三级菜单）" value="menu2-sp"></Option>
              <Option label="非菜单页面" value="non-menu"></Option>
              <Option label="按钮" value="button"></Option>
            </Select>
          </FormItem>
          <FormItem label="标题（title）" prop="title">
            <Input v-model="asyncRoute.title" placeholder="路由标题" type="text">
              <Icon slot="prepend" type="md-create"></Icon>
            </Input>
          </FormItem>
          <template v-if="asyncRoute.type !== 'button'">
            <FormItem label="菜单图标名（icon）" prop="icon">
              <Input v-model="asyncRoute.icon" placeholder="菜单图标名，参考iView的图标库" type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
            <FormItem label="路由名（name）" prop="name">
              <Input v-model="asyncRoute.name" placeholder="路由名" type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
            <FormItem label="路由访问路径（path）" prop="path">
              <Input v-model="asyncRoute.path"
                     placeholder="一级菜单路径必须以 ' / '开头，二级及其他路径可不以 ' / '开头，区别详见前端readme文档 "
                     type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
            <FormItem label="vue组件（component）" prop="component">
              <Input v-model="asyncRoute.component" placeholder="组件位于src下路径，例如：views/main/main.vue"
                     type="text">
                <Icon slot="prepend" type="md-create"></Icon>
              </Input>
            </FormItem>
          </template>
          <Row>
            <Col span="14">
              <FormItem label="接口地址">
                <Input v-model="asyncRoute.url" placeholder="接口地址" type="text">
                  <Icon slot="prepend" type="md-create"></Icon>
                </Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem :label-width="90" label="请求方式">
                <Select v-model="asyncRoute.httpMethod" filterable placeholder="请选择">
                  <Option value="GET">get</Option>
                  <Option value="PUT">put</Option>
                  <Option value="POST">post</Option>
                  <Option value="DELETE">delete</Option>
                </Select>
              </FormItem>
              <Icon slot="prepend" type="md-create"></Icon>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Button :disabled="isSubmitDisabled" type="primary" @click="edithandleSubmit('asyncRoute')">保存</Button>
            <Button type="default" @click="editCancel">取消</Button>
          </Row>
        </Form>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'routers',
  inject: ['reload'],
  data() {
    return {
      props: {label: 'title', children: 'children'},
      currentNode: null,
      isSubmitDisabled: false,
      isNodeEdited: false,
      isNodeAdd: false,
      asyncRoute: null,
      ruleAsyncRoute: {
        title: [{required: true, message: '请填写路由标题', trigger: 'blur'}],
        name: [{required: true, message: '请填写路由名', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /[\u4E00-\u9FFF]+/g
              if (!reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入合法的路由名，不能包含中文。'))
              }
            },
            trigger: 'blur'
          }
        ],
        path: [{required: true, message: '请填写路由访问路径', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /[\u4E00-\u9FFF]+/g
              if (!reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入合法的路由路径，不能包含中文。'))
              }
            },
            trigger: 'blur'
          }
        ],
        component: [{required: true, message: '请填写路由对应的Vue组件', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /[\u4E00-\u9FFF]+/g
              if (!reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入合法的组件路径，不能包含中文。'))
              }
            },
            trigger: 'blur'
          }
        ],
        type: [{required: true, message: '请选择该节点的数据类型', trigger: 'blur'}],
        url: [{required: true, message: '请选择该接口地址', trigger: 'blur'}],
        httpMethod: [{required: true, message: '请选择请求方式', trigger: 'blur'}]
      }
    }
  },
  // 判断能否拖拽
  created() {
    this.initAsyncRoute()
  },
  methods: {
    initAsyncRoute() {
      this.asyncRoute = {
        type: '',
        name: '',
        icon: 'ios-folder-outline',
        title: '',
        url: '',
        component: '',
        parentId: null,
        menuId: null,
        id: null,
        orderby: 0,
        httpMethod: '',
        pagePath: ''
      }
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        // init root of tree
        let root = {
          id: 0,
          title: '异步路由配置',
          parentId: null,
          menuId: 0
        }
        resolve([root])
      } else {
        // init leaves of tree
        this.getNodes(node.data.menuId).then(value => {
          return resolve(value)
        })
      }
    },
    // 获取数据
    getNodes(parentId) {
      return new Promise((resolve, reject) => {
        const msg = this.$Message.loading({
          content: '正在获取数据',
          duration: 0
        })
        const [url, httpConfig] = [
          'system/auth/menu',
          parentId
        ]
        this.$http.get(url + '?' + 'parentId=' + httpConfig).then(response => {
          msg()
          resolve(response.data.data)
        }).catch(error => {
          msg()
          this.$Message.error('获取数据失败！')
          reject(error)
        })
      })
    },
    // 新增或者修改
    editNode(node, data, act) {
      this.currentNode = node
      if (act === 'append') {
        this.initAsyncRoute()
        this.asyncRoute.parentId = data.parentId === null ? 0 : data.menuId
        this.isNodeEdited = true
      } else if (act === 'update') {
        this.asyncRoute = data
        this.isNodeEdited = true
      } else if (act === 'edit') {
        this.asyncRoute = data
        this.isNodeAdd = true
      }
    },
    // 删除提示
    removeNodeConfirmed(node, data) {
      this.$Modal.confirm({
        title: '警告',
        content: '确定删除该节点（包括子节点）数据？',
        onOk: () => {
          this.deleteNode(node, data)
        }
      })
    },
    // 确认删除
    deleteNode(node, data) {
      this.$http.delete('system/auth/menu?menuId=' + data.menuId).then(() => {
        this.$Message.success('删除成功！')
        this.remove(node)
      }).catch(() => {
        this.$Message.error('删除失败！')
      })
    },
    // 删除数据
    remove(node) {
      this.$refs['async-router-tree'].remove(node)
    },
    handleSubmit(name) { // 新增提交
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true
          const isAppendNode = this.asyncRoute.id === null
          const msg = this.$Message.loading({
            content: isAppendNode ? '正在添加新节点' : '正在更新节点',
            duration: 0
          })
          this.$http.post('system/auth/menu', this.asyncRoute).then(() => {
            if (isAppendNode) {
              this.append(this.asyncRoute, this.currentNode)
            }
            msg()
            this.$Message.success(isAppendNode ? '添加节点成功！' : '更新节点成功！')
            this.isNodeEdited = false
            this.isSubmitDisabled = false
            this.reload()
          }).catch(() => {
            msg()
            this.isNodeEdited = false
            this.isSubmitDisabled = false
            this.$Message.error(isAppendNode ? '添加节点失败！' : '更新节点失败！')
          })
        }
      })
    },
    // 提交
    edithandleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true
          const isAppendNode = this.asyncRoute.id === null
          const msg = this.$Message.loading({
            content: isAppendNode ? '正在添加新节点' : '正在更新节点',
            duration: 0
          })
          delete this.asyncRoute.createTime
          delete this.asyncRoute.modifyTime
          this.$http.put('system/auth/menu', this.asyncRoute).then(() => {
            if (isAppendNode) {
              this.append(this.asyncRoute, this.currentNode)
            }
            msg()
            this.$Message.success(isAppendNode ? '添加节点成功！' : '更新节点成功！')
            this.isNodeAdd = false
            this.isSubmitDisabled = false
          }).catch(() => {
            msg()
            this.isNodeAdd = false
            this.isSubmitDisabled = false
            this.$Message.error(isAppendNode ? '添加节点失败！' : '更新节点失败！')
          })
        }
      })
    },
    // 新增数据
    append(data, node) {
      this.$refs['async-router-tree'].append(data, node)
    },
    // 取消按钮
    cancel() {
      this.isNodeEdited = false
    },
    // 编辑取消按钮
    editCancel() {
      this.isNodeAdd = false
    },
    // 拖拽
    getItemsUpdated(node, referenceNode, dropType) {
      switch (dropType) {
        case 'inner':
          if (referenceNode.childNodes.length > 1) {
            return this.filterItemsUpdated(referenceNode.childNodes)
          }
          node.data.parentId = referenceNode.data.id
          node.data.orderby = 0
          return [node.data]
        case 'before':
        case 'after':
          return this.filterItemsUpdated(referenceNode.parent.childNodes, referenceNode.data.parentId)
        default:
          break
      }
    },
    // 拖拽
    filterItemsUpdated(children, parentId) {
      const tempArray = []
      for (let i = 0; i < children.length; i++) {
        if (children[i].data.orderby !== (i + 1)) {
          children[i].data.orderby = i + 1
          tempArray.push(children[i].data)
        }
        if (children[i].data.parentId !== parentId) {
          children[i].data.parentId = parentId
          if (!tempArray.includes(children[i].data)) {
            tempArray.push(children[i].data)
          }
        }
      }
      return tempArray
    },
    // 拖拽
    updateDragData(data) {
      const url = 'system/auth/menu'
      this.$http.put(url, data).catch(() => {
        this.$Message.error('拖拽的节点数据更新失败，请刷新数据重新尝试！')
      })
    },
    // 拖拽
    initPutData(node, referenceNode, dropType) {
      const data = this.getItemsUpdated(node, referenceNode, dropType)
      this.updateDragData(data)
    },
    // 拖拽结束时触发的事件
    handleDragEnd(draggingNode, dropNode, dropType) {
      if (dropType !== 'none') {
        // drag success
        this.initPutData(draggingNode, dropNode, dropType)
      }
    },
    // 拖拽后判定
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.parentId === 0 && dropNode.data.parentId === 0 && type === 'inner') {
        // 一级菜单节点不允许降为二、三级节点
        return false
      } else if (draggingNode.data.parentId !== 0 && !dropNode.data.parentId) {
        // 非一级节点不允许拖拽成为一级节点
        return false
      } else if (dropNode.data.id === 0) {
        return type === 'inner'
      }
      return true
    },
    // 判断能否拖拽
    allowDrag(draggingNode) {
      return draggingNode.data.id !== 0
    }
  }
}
</script>

<style lang="less">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .ivu-btn {
    margin-left: 8px;
  }
}

.add-root-btn {
  width: 89px !important;
}

.modal-mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  &-form {
    width: 56%;

    span {
      font-size: 1rem;
    }

    .ivu-btn {
      margin: 0 8px;
    }
  }
}
</style>
